export enum CustomCarrierCodes {
  jtiPickup = "jti_pickup",
}
